import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';


const IconButton = ({ title, onClick, children, className = '' }) => {
  return (
    <Button className={className} onClick={onClick} title={title}>
      {children}
    </Button>
  );
};

IconButton.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
};

const Button = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  display: inline-flex;
  height: 55px;
  justify-content: center;
  padding: 0;
  position: relative;
  width: 55px;

  svg {
    height: 80%;
    width: 80%;
  }

  path {
    fill: currentColor;
  }
`

export default IconButton;
